/* eslint no-unused-vars:0 */

import axios from "axios";

export const incomeNeeds = {
    namespaced: true,
    state: {
        incomeNeeds: 0,
    },
    actions: {
        loadIncomeNeeds ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/households/' + rootGetters['auth/user'].household_id)
                .then(response => {
                    commit('setIncomeNeeds', response.data.data.household.gross_monthly_income_needs);
                    return response;
                })
        },

        saveIncomeNeeds({ commit, getters, rootGetters }) {
            axios.put('/api/households/' + rootGetters['auth/user'].household_id, {
                gross_monthly_income_needs: getters.incomeNeeds
            });
        },
    },
    mutations: {
        setIncomeNeeds (state, incomeNeeds) {
            state.incomeNeeds = incomeNeeds;
        },
    },
    getters: {
        incomeNeeds: state => state.incomeNeeds
    }
};
